// Module
var code = `<base-button btn-context="{{btnContext}}" btn-type="{{btnType}}" btn-size="{{btnSize}}" type="{{type}}"> <i class="fa fa-times"></i> <span ng-if="!btnIconOnly">{{ 'Generic.Close' | translate }}</span> </base-button> `;
// Exports
module.exports = code;